import styled from "styled-components";
import { primaryColor } from "../constants/constants";
import useScreenSize from "../hooks/useScreenSize";

interface StyledHeaderProps {
  fontSize: string;
}

const StyledHeader = styled("h1")<StyledHeaderProps>(({ theme, fontSize }) => ({
  color: primaryColor,
  fontSize: fontSize,
  margin: 0,
  textAlign: "center",
}));

const PageHeader = (prop: { title: string }) => {
  const { isLessThanMd, isGreaterThanOrEqualMd } = useScreenSize();
  let fontSize = "2rem";
  if (isLessThanMd) {
    fontSize = "2.7rem";
  } else if (isGreaterThanOrEqualMd) {
    fontSize = "4.5rem";
  }

  return <StyledHeader fontSize={fontSize}>{prop.title}</StyledHeader>;
};

export default PageHeader;
